import { TableColumnsType } from "antd";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { ReleaseNoteCreateResult } from "api/interfaces/settingsInterface.interface";
import { CommonTable } from "components/atoms/table/AntdTable";
import Status, { StatusType } from "components/blocks/status/Status";
import { TableTemplate } from "components/templates/default/table/TableTemplate";
import React from "react";
import AddModal from "./add";
import ReleaseNote from "pages/recorders/edit/updated/modal/ReleaseNote";
type Props = {
  onModal: (type: string, row?: ReleaseNoteCreateResult) => void;
  columns: TableColumnsType<any>;
  data: Array<any>;
  paginationInfo: BasePagination;
  onChangePage: (page: number, totalRows: number) => void;
  tablePending: boolean;
  status: StatusType;
  isAddModal: boolean;
  selectedRow?: ReleaseNoteCreateResult | undefined;
  onUpdate: (data: ReleaseNoteCreateResult) => void;
  onDelete: (id: string) => void;
  isUpdateLoading: boolean;
  onClickSearch: (keyword: string) => void;
  isPreviewModal: boolean;
};
export default function ReleaseNotesPrsenter(props: Props) {
  const {
    onModal,
    columns,
    data,
    paginationInfo,
    onChangePage,
    tablePending,
    status,
    isAddModal,
    selectedRow,
    onUpdate,
    onDelete,
    isUpdateLoading,
    onClickSearch,
    isPreviewModal,
  } = props;
  return (
    <>
      <TableTemplate
        onClickBtn={() => onModal("add")}
        buttonLabel="Add Release Note"
        titleComponent="Release Notes"
        centerChildren={<Status status={status} />}
        keyword={paginationInfo.keyword}
        onClickSearch={onClickSearch}
        data-testid="manager-release-notes-release-notes-table-template-modal"
      >
        <CommonTable
          columns={columns}
          dataSource={data}
          queryInfo={paginationInfo}
          onChangePage={onChangePage}
          loading={tablePending}
          rowKey="id"
        />
      </TableTemplate>
      {isAddModal && (
        <AddModal
          onModal={() => onModal("add")}
          selectedRow={selectedRow}
          onUpdate={onUpdate}
          onDelete={onDelete}
          isLoading={isUpdateLoading}
          isOpen={isAddModal}
        />
      )}

      {isPreviewModal && (
        <ReleaseNote
          onClickCancel={() => onModal("preview")}
          releaseNote={selectedRow?.content ?? null}
        />
      )}
    </>
  );
}
